export const OfferJoinStatus = Object.freeze({
    canceled: Symbol('new'),
    new: Symbol('processing'),
    processing: Symbol('completed'),
});

export function getStatusText(status) {
    return {
        [OfferJoinStatus.new]: 'Nowy',
        [OfferJoinStatus.processing]: 'Przetwarzanie',
        [OfferJoinStatus.completed]: 'Zakończone',
    }[OfferJoinStatus[status]];
}
